// extracted by mini-css-extract-plugin
export default {"modificationContainer":"Modification_modificationContainer__mf+T4","modificationBlock":"Modification_modificationBlock__uaOP7"};